import type { ComponentProps } from "react";
import { cx } from "class-variance-authority";
import getCountryISO3 from "country-iso-2-to-3";

import { Input } from "./Input";

import * as styles from "./PhoneInputWithFlag.module.scss";

const PhoneInputWithFlag = ({
  ref,
  countryCode,
  inputClassName,
  ...rest
}: ComponentProps<typeof Input> & {
  countryCode?: string;
  ref?: React.Ref<HTMLInputElement>;
}) => {
  return (
    <Input
      {...rest}
      ref={ref}
      inputClassName={cx(styles.inputOverride, inputClassName)}
      prefixIcon={
        <img
          src={`/flags/${getCountryISO3(countryCode)?.toLowerCase() || "aus"}.png`}
          alt=""
        />
      }
    />
  );
};

PhoneInputWithFlag.displayName = "PhoneInputWithFlag";

export { PhoneInputWithFlag };
